
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import Groups2AddToGroupDialogContent from './groups-2-add-to-group-dialog-content.vue'

@Component({
  components: {
    Groups2AddToGroupDialogContent
  }
})
class Groups1AddToGroupButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean

  @Prop({ default: '' }) selectedItemId?: string
  @Prop({ default: '' }) selectedItemType?: string

  isVisibleAddToGroupRequestDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleAddToGroupRequestDialog = isVisible
  }
}

export default Groups1AddToGroupButton

